<mwe-global-notification-wrapper />
<mwe-page-ribbon />

<div
  [ngClass]="{
    'maintenance-mode': isMaintenanceEnabled(),
    'pb-0': noBottomPadding(),
  }"
  class="page-content"
>
  @if (routeLoaded()) {
    <mwe-header [withBottomMargin]="false">
      <mwe-navbar-header />
    </mwe-header>
  }
  <div class="position-sticky top-0 z-3" [ngClass]="{ 'mb-5 mb-lg-6': showNavBar() }">
    <mwe-toast />
  </div>
  <router-outlet />
</div>

@if (showChatbot()) {
  <mwe-chatbot-popup />
}

@if (!hideFooter()) {
  <ng-content select="[slot='footer']" />
}

@if (showNavBar()) {
  <mwe-navbar-footer />
}

<mwe-aria-live />
